<template>
	<Transition name="fade">
		<section
			v-if="isActive"
			class="fixed inset-0 z-[9999] flex min-h-screen flex-col items-center overflow-y-auto bg-slate-50 px-6 py-10 text-center font-sans text-neutral-900 sm:py-0"
			role="alert"
			aria-live="assertive"
			data-testid="maintenance-page"
		>
			<LogoFull
				:aria-hidden="false"
				aria-label="Apropos.jobs"
				class="mt-8 h-auto w-[250px] sm:mt-28 sm:w-[350px]"
			/>

			<div
				class="flex w-full max-w-[720px] flex-1 flex-col items-center pt-16 sm:pt-[72px]"
			>
				<div
					class="flex size-[120px] shrink-0 items-center justify-center rounded-full bg-gray-100 text-slate-700 shadow-md"
					aria-hidden="true"
				>
					<IconWrench size="64" />
				</div>

				<h1
					class="mt-12 mb-0 font-sans text-3xl font-semibold normal-case text-neutral-900 sm:text-4xl"
				>
					We'll be back soon
				</h1>

				<p class="mb-0 mt-3 max-w-[560px] text-base text-[#5F656A]">
					Apropos is undergoing scheduled maintenance.
					<br class="hidden sm:block" />
					Your data is safe, and everything will return to normal
					shortly.
				</p>

				<a
					href="mailto:support@apropos.jobs"
					class="mt-9 inline-flex max-w-full items-center gap-3 rounded-xl border border-neutral-100 bg-white px-5 py-4 text-left text-sm text-gray-600 shadow-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-[#385aca] focus-visible:ring-offset-2 focus-visible:ring-offset-slate-50 sm:px-6"
					data-testid="maintenance-support-link"
				>
					<IconEnvelope
						class="text-gray-600 shrink-0"
						:aria-hidden="true"
					/>
					<span class="min-w-0 break-words">
						Need help? Contact support at
						<span class="text-[#385aca] underline">
							support@apropos.jobs
						</span>
					</span>
				</a>
			</div>
		</section>
	</Transition>
</template>

<script>
import { LogoFull } from '~/components/Logo'
import { IconEnvelope, IconWrench } from '~/components/Icons'

export default {
	name: 'MaintenancePage',
	components: {
		IconEnvelope,
		IconWrench,
		LogoFull
	},
	props: {
		active: {
			type: Boolean,
			default: null
		}
	},
	computed: {
		isActive() {
			if (this.active !== null) {
				return this.active
			}

			return Boolean(
				this.$store &&
					this.$store.state.maintenance &&
					this.$store.state.maintenance.active
			)
		}
	}
}
</script>
